import { render } from "./CoinDown.vue?vue&type=template&id=6b99af18"
import script from "./CoinDown.vue?vue&type=script&lang=js"
export * from "./CoinDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__